import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import { RegularButton } from 'pg-ui-library';

import closeSvg from 'src/assets/close.svg';
import { INote } from 'src/interfaces';
import { NotesForm } from './components/notes-form';
import { NotesTable } from './components/notes-table';

import { CloseIcon, HeaderContainer } from './styles';

const EmploymentNotesTab: React.FC = () => {
  const { t } = useTranslation();
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [note, setNote] = useState<INote | null>(null);
  const modalRef = useRef(null);

  const handleModalClose = () => {
    setIsOpen(false);
  };

  const handleModalOpen = () => {
    setIsOpen(true);
  };

  const onAdd = () => {
    setNote(null);
    handleModalOpen();
  };

  const onEdit = (selectedNote: INote) => {
    setNote(selectedNote);
    handleModalOpen();
  };

  return (
    <>
      <HeaderContainer>
        <RegularButton onClick={onAdd}>{t('employeePage.notesTab.addButton')}</RegularButton>
      </HeaderContainer>

      <ReactModal
        isOpen={modalIsOpen}
        ariaHideApp={false}
        style={{
          overlay: {
            margin: 'auto',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          },
          content: {
            borderRadius: '10px',
            margin: 'auto',
            maxWidth: '600px',
            minWidth: '600px',
            height: 'max-content',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          },
        }}
        onRequestClose={handleModalClose}
        // eslint-disable-next-line no-return-assign
        contentRef={(node: any) => (modalRef.current = node)}
      >
        <CloseIcon src={closeSvg} onClick={handleModalClose} />
        <NotesForm note={note} onSubmit={handleModalClose} />
      </ReactModal>

      <NotesTable onEdit={onEdit} />
    </>
  );
};
export default EmploymentNotesTab;
